export interface RemittanceService {
  id: string;
  name: string;
  tagline: string;
  rate: number;
  fee: number;
  time: string;
  badge: string | null;
  bestFor: string;
  link: string;
  color: string;
}

export const remittanceServices: RemittanceService[] = [
  {
    id: "wise",
    name: "Wise",
    tagline: "Transferencias bancarias",
    rate: 36.50,
    fee: 0.99,
    time: "1-2 días",
    badge: "Mejor Tasa",
    bestFor: "Mejor tasa de cambio",
    link: "https://wise.com/invite/dic/arlindad30",
    color: "emerald",
  },
  {
    id: "remitly",
    name: "Remitly",
    tagline: "Rápido y seguro",
    rate: 35.80,
    fee: 1.99,
    time: "Minutos",
    badge: "Más Rápido",
    bestFor: "Envíos urgentes",
    link: "https://www.remitly.com/r/3ccs1e2j",
    color: "teal",
  },
  {
    id: "worldremit",
    name: "WorldRemit",
    tagline: "Cobertura global",
    rate: 35.50,
    fee: 2.99,
    time: "1-3 días",
    badge: null,
    bestFor: "Cobertura amplia",
    link: "https://worldremit.com",
    color: "cyan",
  },
  {
    id: "westernunion",
    name: "Western Union",
    tagline: "Red física disponible",
    rate: 34.20,
    fee: 4.99,
    time: "Minutos",
    badge: null,
    bestFor: "Retiro en efectivo",
    link: "https://ssqt.co/mQNlL2e",
    color: "slate",
  },
];

export const faqItems = [
  {
    q: "¿Es seguro enviar dinero a Venezuela con estos servicios?",
    a: "Sí. Todos los servicios listados en RemesasVE son empresas reguladas y licenciadas en sus países de operación. Wise, Remitly, Western Union y WorldRemit cuentan con licencias de transmisión de dinero y utilizan cifrado bancario para proteger tus transferencias.",
  },
  {
    q: "¿Con qué frecuencia se actualizan las tasas de cambio?",
    a: "Las tasas de cambio se actualizan diariamente. Los tipos de cambio en el mercado de remesas pueden variar día a día, por lo que te recomendamos verificar siempre antes de enviar tu remesa.",
  },
  {
    q: "¿Cuánto puedo enviar como máximo a Venezuela?",
    a: "Los límites varían por servicio. Wise permite hasta $1,000,000 USD/año según verificación. Remitly hasta $2,999 por transacción para nuevos usuarios. Western Union y WorldRemit también tienen límites propios que aumentan según el nivel de verificación de tu cuenta.",
  },
  {
    q: "¿Qué métodos de pago aceptan estos servicios?",
    a: "La mayoría acepta transferencia bancaria, tarjeta de débito y tarjeta de crédito (con posible cargo adicional). Algunos como Remitly y Western Union también permiten pago en efectivo en agencias autorizadas.",
  },
  {
    q: "¿El receptor en Venezuela necesita una cuenta bancaria?",
    a: "Depende del servicio. Western Union permite retiro en efectivo sin necesidad de cuenta bancaria. Wise y Remitly generalmente requieren cuenta bancaria venezolana. WorldRemit ofrece varias opciones incluyendo depósito en cuenta y recogida en efectivo.",
  },
  {
    q: "¿Hay comisiones ocultas en la comparación?",
    a: "RemesasVE muestra la comisión total de cada servicio incluyendo todos los cargos conocidos. Sin embargo, tu banco emisor podría cobrar comisiones adicionales por transferencias internacionales. Siempre revisa los términos de tu banco.",
  },
  {
    q: "¿En qué moneda recibe el dinero el beneficiario en Venezuela?",
    a: "El beneficiario puede recibir en Bolívares venezolanos (VES) o en dólares americanos (USD), según la opción que elijas al enviar. En Venezuela actualmente muchas transacciones se realizan en dólares.",
  },
];
